import * as S from "./styled"

export const NotFoundPage = () => (
  <S.Wrapper>
    <S.Title>Error 404</S.Title>
    <S.Text>Page not found</S.Text>
  </S.Wrapper>
)
